import { useState } from "react";
import { FileDown } from "lucide-react";
import { API, withPersona } from "@/lib/api";
import { useApp } from "@/context/AppContext";

const inp = "text-[11px] border border-slate-300 rounded px-1.5 py-1 bg-white outline-none focus:border-sky-500";

export function AccessReportButton() {
  const [start, setStart] = useState("");
  const [end, setEnd] = useState("");
  const { persona } = useApp();
  if (!persona?.permissions.includes("audit.export")) return null;
  const open = () => {
    const q = new URLSearchParams();
    if (start) q.set("start", start);
    if (end) q.set("end", end);
    window.open(withPersona(`${API}/audit/access-report.pdf${q.toString() ? `?${q}` : ""}`), "_blank");
  };
  return (
    <div className="flex flex-wrap items-center gap-1.5" data-testid="access-report-export">
      <input data-testid="access-report-start" type="date" value={start} onChange={(e) => setStart(e.target.value)} className={inp} title="From (optional)" />
      <span className="text-[11px] text-slate-400">to</span>
      <input data-testid="access-report-end" type="date" value={end} onChange={(e) => setEnd(e.target.value)} className={inp} title="To (optional)" />
      <button data-testid="access-report-button" onClick={open} className="flex items-center gap-1.5 text-xs font-medium bg-sky-600 hover:bg-sky-700 text-white rounded px-3 py-1.5 transition-colors"><FileDown className="w-3.5 h-3.5" />Access change report</button>
    </div>
  );
}
